/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {InvestmentOfferListMapView} from "../../investment_offer/views/InvestmentOfferListMapView";
import {InvestmentOfferListView} from "../../investment_offer/views/InvestmentOfferListView";
import {InvestmentOfferView} from "../../investment_offer/views/InvestmentOfferView";
const route = [
    {bundlerEntry: "investmentOffers", path: rpAppPath.investmentOffer.base, component: InvestmentOfferView},
    {
        bundlerEntry: "investmentOffers",
        path: [rpAppPath.investmentOffer.investmentCategory.map, rpAppPath.investmentOffer.investmentCategory.subcategory.map],
        component: InvestmentOfferListMapView
    },
    {
        bundlerEntry: "investmentOffers",
        path: [rpAppPath.investmentOffer.investmentCategory.base, rpAppPath.investmentOffer.investmentCategory.subcategory.base],
        component: InvestmentOfferListView
    }
];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_bundler_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {InvestmentOfferListMapView} from "../../investment_offer/views/InvestmentOfferListMapView";
import {InvestmentOfferListView} from "../../investment_offer/views/InvestmentOfferListView";
import {InvestmentOfferView} from "../../investment_offer/views/InvestmentOfferView";
const route = [
    {bundlerEntry: "investmentOffers", path: rpAppPath.investmentOffer.base, component: InvestmentOfferView},
    {
        bundlerEntry: "investmentOffers",
        path: [rpAppPath.investmentOffer.investmentCategory.map, rpAppPath.investmentOffer.investmentCategory.subcategory.map],
        component: InvestmentOfferListMapView
    },
    {
        bundlerEntry: "investmentOffers",
        path: [rpAppPath.investmentOffer.investmentCategory.base, rpAppPath.investmentOffer.investmentCategory.subcategory.base],
        component: InvestmentOfferListView
    }
];

(function () {
    rpClient(route);
})();
